import { GuiBase } from "../GuiBase";

export class GuiLoginRecover2FA extends GuiBase {

    constructor() {
        super("Login2FA");
    }

}
